// src/context/EventsContext.js
import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';
import { getLatestEvents, getUpcomingEvents } from '../services/EventService';

// Create events context
export const EventsContext = createContext();

// Events provider component
export const EventsProvider = ({ children }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      try {
        // Use the service with fallback data
        const data = await getLatestEvents();
        setEvents(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching events:', err);
        setError('Failed to load events. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  // Context value
  const value = {
    events,
    loading,
    error,
    setEvents
  };

  return (
    <EventsContext.Provider value={value}>
      {children}
    </EventsContext.Provider>
  );
};
